import { AlpineComponent } from '@alpinejs/csp';

const ActionBar = (): AlpineComponent => ({
  scrolled: false,

  init() {
    this.onScroll();
  },

  onScroll() {
    this.scrolled = window.scrollY > 100;
  },
  getClassName() {
    return this.scrolled ? 'action-bar--scrolled' : '';
  }
});

export default ActionBar;
